module.exports = __webpack_public_path__ + "static/assets/4ef85a4bc0ca916802fd7446ecf7e0db.svg";